export type ALL_LOCALES_TYPE = "es" | "fr" | "en" | "ar"

// ALL_LOCALES in all-enum.ts
export const enum LOCALES {
  FR = "fr",
  EN = "en",
  ES = "es",
  AR = "ar"
}
export const ALL_LOCALES: LOCALES[] = [LOCALES.EN, LOCALES.FR, LOCALES.ES, LOCALES.AR]

export const DEFAULT_LOCALE: LOCALES = LOCALES.EN
export const LAST_LOCALE_LOCAL_STORAGE_ID = "lastUsedLocale"
export const USER_CHANGE_LOCALE_LOCAL_STORAGE_ID = "userChangedLocale"
export const PARAM_OVERRIDEN_LOCALE = "locale"

export type JCoreTranslateFn = (
  key: string,
  params?: string | number | Array<string | number>,
  paramLocale?: LOCALES
) => string

export interface INavigator extends NavigatorLanguage {
  readonly userLanguage?: string
}

export interface ILocaleTranslation {
  [key: string]: string
}

export interface ILanguageState {
  locale: LOCALES
}

export interface ITranslation {
  en: string
  fr: string
  es: string
  ar: string
}

export interface ILanguageService {
  getLocales(): LOCALES[]
  getLocale(): LOCALES
  getDateFnsLocale(displayTime?: boolean): any
  getDefaultLocale(): LOCALES
  setLocale(locale: LOCALES): Promise<void>
  translate(params: ITranslateParams): string
  is12HoursTimeFormat(): boolean
  isValidLocale(locale: LOCALES): boolean
  getDateFnsDateFormat(): string
}

export interface ITranslateParams {
  key: string
  params?: (string | number) | Array<string | number>
  locale?: LOCALES
}

export interface ITranslationsByLocale {
  [locale: string]: ILocaleTranslation
}

export type JTranslationByLocale = { [locale in LOCALES]: string }
